import React from "react";
import PropTypes from "prop-types";
import BlanketDetailedInformationBase from "../../../../features/bonds/blanket/components/BlanketDetailedInformationBase";
import { BLANKET_DETAILED_INFO_CONFIG } from "../../../../features/bonds/blanket/components/blanketDetailedInformationConfig";

const BlanketHistoricDetailedInformation = (props) => (
  <BlanketDetailedInformationBase
    config={BLANKET_DETAILED_INFO_CONFIG.historic}
    {...props}
  />
);

BlanketHistoricDetailedInformation.propTypes = {
  control: PropTypes.object.isRequired,
  errors: PropTypes.object,
  watch: PropTypes.func.isRequired,
};

export default BlanketHistoricDetailedInformation;
